export const generateGiftCardCode = (prefix?: string) => {
  const charactersScope = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789'
  const codeLength = 12
  let result = ''

  Array.from(Array(codeLength)).forEach(() => {
    result += charactersScope.charAt(Math.floor(Math.random() * charactersScope.length))
  })

  if (prefix) {
    return `${prefix}_${result}`
  }

  return result
}
